<template>
<div>
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a @click="$router.push('/home')" class="navbar-item">
                <img id="nav-logo" :src="`${publicPath}img/logo.png`" alt="eWATER Services">
            </a>
            <a @click="toggleMenu()" role="button" class="navbar-burger burger" :class="{ 'is-active': navbarVisible }" aria-label="menu" aria-expanded="false" data-target="offcanvasMenu">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div id="offcanvasMenu" class="navbar-menu noselect" :class="{ 'is-active': navbarVisible }">
            <div class="navbar-start">
                <a :href="`${process.env.VUE_APP_ACCOUNTS_URL}/login?redirect`" class="navbar-item">
                    <span class="icon">
                        <i class="fa fa-lock"> </i>
                    </span>
                    <span>{{ $t("Login") }}</span>
                </a>
                <p class="navbar-item has-text-centered">
                    <span class="has-text-grey-light is-size-7">{{ $t("Version") }}: {{ version }}</span>
                </p>
            </div>
        </div>
    </nav>
</div>
</template>

<script>

export default {
  name: "Header",
  data () {
      return {
          navbarVisible: false
      }
  },
  methods: {
    toggleMenu: function() {
        this.navbarVisible = !this.navbarVisible;
    }
  }
};
</script>